import { createSlice } from "@reduxjs/toolkit";

export const SearchResult = createSlice({
  name: "SearchResult",
  initialState: {
    isSearchResultAvailable: false,
    data: [],
  },
  reducers: {
    setSearchResults: (state, { payload }) => {
      state.isSearchResultAvailable = true;
      state.data = payload;
    },
    updateSearchResults: (state, { payload }) => {
      if (state.isSearchResultAvailable) {
        const index = state.data.findIndex((candidate) => candidate.number === payload.number);
        state.data[index] = { ...state.data[index], isCandidate: payload.isCandidate };
      }
    },
    removeSearchResults: (state) => {
      state.data = [];
      state.isSearchResultAvailable = false;
    },
  },
});

export const { setSearchResults, updateSearchResults, removeSearchResults } = SearchResult.actions;

export const SearchResultReducer = SearchResult.reducer;
